/**
 * The app's one monospace stack (docs/design-system.md §2): IDs, codes, timestamps, ranges and
 * passwords. Each platform's own UI mono first (SF Mono on Apple, Menlo before it), then Consolas for
 * Windows and the generic family last. `check-structure.sh` rule 26 fails on any other monospace
 * spelling, so a face is chosen here, once.
 */
export const MONO_FONT_FAMILY = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
